import { getWindow } from '@ggs/utils'

/**
 * @typedef {Object} UrlParamsHook
 * @property {function} getPathParam
 * @property {function} getPathQueryValue
 * @property {function} removeQueryParam
 */

/**
 * Hook that expose utilities to create (activate) Drupal account.
 * @return {UrlParamsHook}
 */
function useUrlParams() {
  const currentPath = /** @type {string} */ (getWindow('location.pathname') || '')
  const currentQuery = /** @type {string} */ (getWindow('location.search') || '')
  const currentPathParts = currentPath.split('/')
  // console.log('currentPathParts:', currentPathParts)

  /**
   * Get path parameter from path part index.
   * @param {number} index Url part index
   * @return {string|null}
   */
  const getPathParam = (index) => {
    return currentPathParts[index] || null
  }

  /**
   * Get path query value from path.
   * @param {string} paramName Parameter name
   * @return {string|null}
   */
  const getPathQueryValue = (paramName) => {
    const searchString = currentQuery.substring(1)
    const params = searchString.split('&')

    for (let i = 0; i < params.length; i++) {
      const val = params[i].split('=')
      if (val[0] === paramName) {
        return val[1]
      }
    }
    return null
  }

  /**
   * Remove query key with value from url string.
   *
   * @param {string} url
   * @param {string} queryKey
   * @param {string} queryValue
   *
   * @return {string}
   */
  const removeQueryParam = (url, queryKey, queryValue) => {
    // Remove only the "queryKey={queryValue}" parameter from the URL string
    const pattern = new RegExp(`${queryKey}=${queryValue}([&]?)`)
    let urlWithoutQueryArg = url.replace(pattern, '')
    if (urlWithoutQueryArg.includes('?') && (urlWithoutQueryArg.endsWith('?') || urlWithoutQueryArg.endsWith('&'))) {
      urlWithoutQueryArg = urlWithoutQueryArg.slice(0, -1)
    }
    return urlWithoutQueryArg
  }

  return {
    getPathParam,
    getPathQueryValue,
    removeQueryParam
  }
}
export default useUrlParams
